/** Escape % and _ for ILIKE patterns, and strip chars that break PostgREST or=(...) syntax. */
export function sanitiseSearch(s: string): string {
    return s.replace(/[,()]/g, " ").trim().replace(/\\/g, "\\\\").replace(/%/g, "\\%").replace(/_/g, "\\_");
}
